import React from 'react';
import "./Gallery.css"
import Title from "../Title/Title"
import pic1 from "../../images/Memories/pic1.jpeg"
import pic2 from "../../images/Memories/pic2.jpeg"
import pic3 from "../../images/Memories/pic3.jpeg"
import pic4 from "../../images/Memories/pic4.jpeg"
import pic5 from "../../images/Memories/pic5.jpeg"
import pic6 from "../../images/Memories/pic6.jpeg"
import pic7 from "../../images/Memories/pic7.jpeg"
import pic8 from "../../images/Memories/pic8.jpeg"
import pic9 from "../../images/Memories/pic9.jpeg"

function App() {
  return (
    <div className="gallery-container">

      <div style={{margin:"50px 0"}}>
        <Title title={"Memories"}/>
      </div>
      <div class="gallery">
      <img src={pic3} alt="" />
      <img src={pic1}/>
<img src={pic2} />
<img src={pic4} />
<img src={pic5} />
<img src={pic6}  />
<img src={pic7} />
<img src={pic8} />
<img src={pic9} />
</div>
    </div>
  );
}

export default App;